import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './index.css'
import App from './App.tsx'
import PublicPublishPage from './components/public/PublicPublishPage.tsx'
import { ErrorBoundary } from './components/ui/ErrorBoundary.tsx'
import { initSentry } from './utils/sentry.ts'

// Initialize Sentry before anything else
initSentry()

// Register service worker for PWA support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Service worker registration failed - app works fine without it
    });
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/public/campaigns/:campaignId/spaces/*" element={<PublicPublishPage />} />
          <Route path="/:tab?" element={<App />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
)
